import http from './http.js';
import { getSiteUrl } from '../utils';

let globalConfig = {};

const endpoint = (path, config = globalConfig) => `${config.endpoint}${path}`;

const request = async promise => {
  try {
    const response = await promise;
    const data = await response.json();
    return {
      data,
      status: response.status,
      headers: Object.fromEntries(response.headers.entries()),
    };
  } catch (error) {
    if (error.response) {
      const data = await error.response.json().catch(() => ({}));
      const err = new Error(error.message);
      err.response = { status: error.response.status, data };
      throw err;
    }
    throw error;
  }
};

const methods = {
  setConfig: config => (globalConfig = { ...globalConfig, ...config }),
  create: (body, config = globalConfig) =>
    request(
      http.post(endpoint(`/charts`), {
        json: {
          ...body,
          confirmUrl: config.confirmUrl,
          deUrl: `${getSiteUrl()}/share`,
        },
      }),
    ),
  get: ({ id }) => request(http.get(endpoint(`/charts/${id}`))),
  list: ({ token }) => request(http.get(endpoint(`/charts`), { searchParams: { token } })),
  confirm: ({ token }) =>
    request(http.get(endpoint(`/charts/confirm`), { searchParams: { token } })),
  delete: ({ token, id = '' }) =>
    request(http.delete(endpoint(`/charts/${id}`), { searchParams: { token } })),
  getEmail: ({ body }) =>
    request(
      http.post(endpoint(`/mail/${body.email}`), {
        json: {
          ...body,
          deUrl: `${getSiteUrl()}/share`,
        },
      }),
    ),
};

const error = method => () => {
  throw new Error(`Unkown method: ${method}`);
};

const main = ({ method, ...rest }) => (methods[method] || error(method))(rest);
Object.entries(methods).forEach(([name, fn]) => (main[name] = fn));

export default main;
